// import deepExtend from './../utilities/deepExtend.js';
import closestParent from './../utilities/closestParent.js';

export default function ScrollTo() {
  return {
    init: () => {
      document.addEventListener('click', (event) => {
        const target = closestParent(
          event.target,
          'a[href^="#"]:not([href="#"]):not([data-w-noscrollto])'
        );
        if (target) {
          event.preventDefault();

          // remove open menu in any case
          // document.documentElement.classList.remove(
          //     'w-has-menu-open'
          // );
          // const closeMenuEvent = new CustomEvent(
          //     'w.FixedMenuHandler.close'
          // );
          // document.dispatchEvent(closeMenuEvent);

          const scrollTarget = document.querySelector(
            target.getAttribute('href')
          );
          if (scrollTarget)
            scrollTarget.scrollIntoView({
              behavior: 'smooth',
            });
        }
      });
    }
  };
}
